<template>
  <div class="product-upsell critical-component-hide">
    <product-recommendations
      ref="productRecommendations"
      class="product-upsell__recommendations"
      :container-ref="$refs.productRecommendations"
      :liquid="{
        productId: addedLineItem?.product_id,
        sectionId: liquid.sectionId,
        title: liquid.title,
      }"
      :product-count="productCount"
      :product-upsell-splide-settings-cart-drawer="productUpsellSplideSettingsCartDrawer"
      :products="{
        count: products.count,
        dynamic: [],
        section: products.section,
        section_collection: products.section_collection,
      }"
      :recommendations="recommendations"
      location="cart-drawer"
      @has-local-products="$emit('has-local-products', $event)"
    />
  </div>
</template>

<script>

/**
 * Vue: Product upsell (product-upsell)
 * -----------------------------------------------------------------------------
 * Product upsell wrapper for cart drawer recommendations.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {String} liquid.title - Section title.
 * @param {Number} [productCount] - Number of products to display.
 * @param {Boolean} [productUpsellSplideSettingsCartDrawer] - Enable product
 * upsell splide settings for cart drawer.
 * @param {Object} products - Object to define fallback products.
 * @param {Object} recommendations - Recommendation settings.
 */
import { mapState } from 'vuex'

import ProductRecommendations from '~async/product-recommendations/product-recommendations'

export default {
  name: 'ProductUpsell',

  components: {
    ProductRecommendations,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        title: '',
      }),
      required: true,
    },
    productCount: {
      type: Number,
      default: 4,
      required: true,
    },
    products: {
      type: Object,
      default: () => ({
        count: 0,
        dynamic: [],
        section: [],
        section_collection: [],
      }),
      required: true,
    },
    productUpsellSplideSettingsCartDrawer: {
      type: Boolean,
      default: false,
    },
    recommendations: {
      type: Object,
      default: () => ({
        enable: true,
        type: 'RELATED',
      }),
      required: true,
    },
  },

  emits: {
    'has-local-products': (value) => typeof value === 'boolean',
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
    }),

    /**
     * Compute line item that was just added.
     * @returns {Object}
     */
    addedLineItem() {
      return this.cart.items[0]
    },
  },
}
</script>

<style lang="scss">
@import './product-upsell';
</style>
